/**
 * 개발용 빌드라면 const isProductionBuild = false
 * 실서버용 빌드라면 const isProductionBuild = true
 * */

const isProductionBuild = true;
// 테스트 전용
// const isProductionBuild = false;

/**
 * 개발용 실행 config
 * 개발용 서버에 맞춰 수정할 것
 */
class DevelopmentHostConfig implements KeyFlowHostConfig {
  protocol = 'http';
  ip = 'localhost';
  port = '8080';
  cloudfront = {
    protocol: 'https',
    baseURL: 'd1j54tpatsts3n.cloudfront.net',
  };
  isSelfOrganized = false;
}

/**
 * 개발용 빌드 config
 * 개발용 서버에 맞춰 수정할 것
 */

class DevProductionHostConfig implements KeyFlowHostConfig {
  protocol = 'http';
  ip = '192.168.10.163';
  port = '4000';
  cloudfront = {
    protocol: 'https',
    baseURL: 'd1j54tpatsts3n.cloudfront.net',
  };
  isSelfOrganized;

  constructor(isSelfOrganized = false) {
    this.isSelfOrganized = isSelfOrganized;
    if (isSelfOrganized) {
      this.ip = window.location.hostname;
      this.port = window.location.port;
      this.protocol = window.location.protocol;
    }
  }
}
class DevDomainHostConfig implements KeyFlowHostConfig {
  protocol = 'http';
  ip = '192.168.10.163';
  port = '5000';
  cloudfront = {
    protocol: 'https',
    baseURL: 'd1j54tpatsts3n.cloudfront.net',
  };
  isSelfOrganized;

  constructor(isSelfOrganized = false) {
    this.isSelfOrganized = isSelfOrganized;
    if (isSelfOrganized) {
      this.ip = window.location.hostname;
      this.port = window.location.port;
      this.protocol = window.location.protocol;
    }
  }
}

/**
 * 실서버용 빌드 config
 * 실서버용 주소가 바뀌면 수정할 것
 */

class RealProductionHostConfig implements KeyFlowHostConfig {
  protocol = 'http';
  ip = '125.7.223.51';
  port = '4000';
  cloudfront = {
    protocol: 'https',
    baseURL: 'd3la6wprmwym21.cloudfront.net',
  };
  isSelfOrganized;

  constructor(isSelfOrganized = false) {
    this.isSelfOrganized = isSelfOrganized;
    if (isSelfOrganized) {
      this.ip = window.location.hostname;
      this.port = window.location.port;
      this.protocol = window.location.protocol;
    }
  }
}
class RealDomainHostConfig implements KeyFlowHostConfig {
  protocol = 'https';
  ip = 'archive.wkbl.or.kr';
  port;
  contextPath = 'BACK';
  cloudfront = {
    protocol: 'https',
    baseURL: 'd3h6bn5qtjue6h.cloudfront.net',
  };
  isSelfOrganized;

  constructor(isSelfOrganized = false) {
    this.isSelfOrganized = isSelfOrganized;
    if (isSelfOrganized) {
      this.ip = window.location.hostname;
      this.port = window.location.port;
      this.protocol = window.location.protocol;
    }
  }
}

export default {
  dev: new DevelopmentHostConfig(),
  prod: isProductionBuild ? new RealProductionHostConfig() : new DevProductionHostConfig(),
  domain: isProductionBuild ? new RealDomainHostConfig() : new DevDomainHostConfig(),
};
